import * as React from "react";
const SvgRoundedStar = ({ title, titleId, ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 17"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      d="M7.35 2.099a.7.7 0 0 1 1.294 0l1.702 4.097 4.02.38a.7.7 0 0 1 .395 1.224l-3.198 2.79 1.105 4.194a.7.7 0 0 1-1.052.77l-3.613-2.295-3.614 2.295a.7.7 0 0 1-1.053-.769l1.102-4.195-3.196-2.793a.7.7 0 0 1 .395-1.224l4.016-.377L7.351 2.1Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgRoundedStar;
